export interface PhoneCode {
	country: string
	code: string
	dial: string
}

export const phoneCodes: PhoneCode[] = [
	{ country: 'United States', code: 'US', dial: '+1' },
	{ country: 'United Kingdom', code: 'GB', dial: '+44' },
	{ country: 'Canada', code: 'CA', dial: '+1' },
	{ country: 'France', code: 'FR', dial: '+33' },
	{ country: 'Germany', code: 'DE', dial: '+49' },
	{ country: 'Australia', code: 'AU', dial: '+61' },
	{ country: 'Brazil', code: 'BR', dial: '+55' },
	{ country: 'India', code: 'IN', dial: '+91' },
	{ country: 'Japan', code: 'JP', dial: '+81' },
	{ country: 'China', code: 'CN', dial: '+86' },
	{ country: 'Mexico', code: 'MX', dial: '+52' },
	{ country: 'Spain', code: 'ES', dial: '+34' },
	{ country: 'Italy', code: 'IT', dial: '+39' },
	{ country: 'Netherlands', code: 'NL', dial: '+31' },
	{ country: 'Belgium', code: 'BE', dial: '+32' },
	{ country: 'Switzerland', code: 'CH', dial: '+41' },
	{ country: 'Sweden', code: 'SE', dial: '+46' },
	{ country: 'Norway', code: 'NO', dial: '+47' },
	{ country: 'Denmark', code: 'DK', dial: '+45' },
	{ country: 'Finland', code: 'FI', dial: '+358' },
	{ country: 'Portugal', code: 'PT', dial: '+351' },
	{ country: 'Ireland', code: 'IE', dial: '+353' },
	{ country: 'Austria', code: 'AT', dial: '+43' },
	{ country: 'Poland', code: 'PL', dial: '+48' },
	{ country: 'Czech Republic', code: 'CZ', dial: '+420' },
	{ country: 'Romania', code: 'RO', dial: '+40' },
	{ country: 'Hungary', code: 'HU', dial: '+36' },
	{ country: 'Greece', code: 'GR', dial: '+30' },
	{ country: 'Turkey', code: 'TR', dial: '+90' },
	{ country: 'Russia', code: 'RU', dial: '+7' },
	{ country: 'Ukraine', code: 'UA', dial: '+380' },
	{ country: 'South Korea', code: 'KR', dial: '+82' },
	{ country: 'Singapore', code: 'SG', dial: '+65' },
	{ country: 'Hong Kong', code: 'HK', dial: '+852' },
	{ country: 'Taiwan', code: 'TW', dial: '+886' },
	{ country: 'Thailand', code: 'TH', dial: '+66' },
	{ country: 'Malaysia', code: 'MY', dial: '+60' },
	{ country: 'Indonesia', code: 'ID', dial: '+62' },
	{ country: 'Philippines', code: 'PH', dial: '+63' },
	{ country: 'Vietnam', code: 'VN', dial: '+84' },
	{ country: 'New Zealand', code: 'NZ', dial: '+64' },
	{ country: 'South Africa', code: 'ZA', dial: '+27' },
	{ country: 'Nigeria', code: 'NG', dial: '+234' },
	{ country: 'Kenya', code: 'KE', dial: '+254' },
	{ country: 'Egypt', code: 'EG', dial: '+20' },
	{ country: 'Morocco', code: 'MA', dial: '+212' },
	{ country: 'Saudi Arabia', code: 'SA', dial: '+966' },
	{ country: 'United Arab Emirates', code: 'AE', dial: '+971' },
	{ country: 'Israel', code: 'IL', dial: '+972' },
	{ country: 'Argentina', code: 'AR', dial: '+54' },
	{ country: 'Colombia', code: 'CO', dial: '+57' },
	{ country: 'Chile', code: 'CL', dial: '+56' },
	{ country: 'Peru', code: 'PE', dial: '+51' },
	{ country: 'Pakistan', code: 'PK', dial: '+92' },
	{ country: 'Bangladesh', code: 'BD', dial: '+880' },
	{ country: 'Sri Lanka', code: 'LK', dial: '+94' },
	{ country: 'Luxembourg', code: 'LU', dial: '+352' },
	{ country: 'Iceland', code: 'IS', dial: '+354' },
	{ country: 'Croatia', code: 'HR', dial: '+385' },
	{ country: 'Bulgaria', code: 'BG', dial: '+359' },
	{ country: 'Slovakia', code: 'SK', dial: '+421' },
	{ country: 'Slovenia', code: 'SI', dial: '+386' },
	{ country: 'Lithuania', code: 'LT', dial: '+370' },
	{ country: 'Latvia', code: 'LV', dial: '+371' },
	{ country: 'Estonia', code: 'EE', dial: '+372' },
	{ country: 'Malta', code: 'MT', dial: '+356' },
	{ country: 'Cyprus', code: 'CY', dial: '+357' },
	{ country: 'Qatar', code: 'QA', dial: '+974' },
	{ country: 'Kuwait', code: 'KW', dial: '+965' },
	{ country: 'Bahrain', code: 'BH', dial: '+973' },
	{ country: 'Oman', code: 'OM', dial: '+968' },
	{ country: 'Jordan', code: 'JO', dial: '+962' },
	{ country: 'Lebanon', code: 'LB', dial: '+961' },
	{ country: 'Ghana', code: 'GH', dial: '+233' },
	{ country: 'Tanzania', code: 'TZ', dial: '+255' },
	{ country: 'Uganda', code: 'UG', dial: '+256' },
	{ country: 'Ethiopia', code: 'ET', dial: '+251' },
	{ country: 'Tunisia', code: 'TN', dial: '+216' },
	{ country: 'Senegal', code: 'SN', dial: '+221' },
	{ country: "Ivory Coast", code: 'CI', dial: '+225' },
	{ country: 'Cameroon', code: 'CM', dial: '+237' },
	{ country: 'Algeria', code: 'DZ', dial: '+213' },
]

/** Look up a dial code by alpha-2 country code */
export const getDialCode = (alpha2: string): string | undefined =>
	phoneCodes.find((p) => p.code === alpha2)?.dial

/** Build a flag URL for a country code */
export const getFlagUrl = (alpha2: string): string =>
	`https://flagcdn.com/w20/${alpha2.toLowerCase()}.png`
